export const ENGRAVING_MESSAGE_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
}

export const NFT_EXCLUSIVE_CONTENT_STATUS = {
  AVAILABLE: 'available',
  REDEEMED: 'redeemed'
}

export const NFT_ACTIONS_STEPS = {
  NFT_DETAILS: 'nftDetails',
  TRANSFER: 'transfer',
  SELL: 'sell',
  CANCEL_LISTING: 'cancelListing',
  CONFIRM_TRANSFER: 'confirmTransfer',
  CONFIRM_SELL: 'confirmSell',
  TRANSFER_CONFIRMED: 'transferConfirmed'
}

export const NFT_CONTENT_TYPE = {
  TEXT: 'text',
  MARKDOWN: 'markdown',
  HTML: 'html',
  URL: 'url'
}
